export const decode = (encodedString: string): string => {
  if (!encodedString) return '';

  return typeof window !== 'undefined'
    ? atob(encodedString)
    : Buffer.from(encodedString, 'base64').toString();
};
